import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import '../../../content/css/PortfolioAnalysis/SpinnerSelectControl.css';

export default class SpinnerSelectControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentIndex: this.props.initialValue,
            minSpanWidth: this.props.items.reduce((max, str) => Math.max(max, str.length), 0)
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.initialValue != prevProps.initialValue) {
            this.setState({ currentIndex: this.props.initialValue });
        }
    }

    handleToggleNext = () => {
        let newIndex = (this.state.currentIndex + 1) % this.props.items.length;
        this.toggle(newIndex);
    }

    handleTogglePrevious = () => {
        let newIndex = (this.state.currentIndex - 1 + this.props.items.length) % this.props.items.length;
        this.toggle(newIndex);
    }

    toggle = (index) => {
        this.setState(({ currentIndex: index, }));
        this.props.onChange(index, this.props.items[index]);
    }

    render() {
        const spanStyle = { minWidth: this.state.minSpanWidth * 8 + "px" };
        return (
            <div className="spinner-container">
                <button className="arrow-button" onClick={this.handleTogglePrevious}>
                    <Glyphicon glyph='chevron-left' />
                </button>
                <span style={spanStyle}>{this.props.items[this.state.currentIndex]}</span>
                <button className="arrow-button" onClick={this.handleToggleNext}>
                    <Glyphicon glyph='chevron-right' />
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/FilterPanel/SpinnerSelectControl.js